import { gql } from '@apollo/client';
const PRODUCT_VARIANT = gql `
  fragment ProductVariantFragment on ProductVariantNode {
    id
    status
    canBeRemoved
    canBeEdited
    canBeArchived
    currentPrice {
      id
      price
      currency {
        id
        name
        isoCode
      }
    }
    color {
      id
      name
      chain
      tape
      slider
      previewColor
    }
    size {
      id
      name
    }
    priceHistory {
      edges {
        node {
          createdDate
          modifiedDate
          id
          price
          currency {
            id
            isoCode
          }
        }
      }
    }
  }
`;
export default PRODUCT_VARIANT;
